import type { useI18n } from '@bravemove/i18n/react';
import { translateApiError } from './errors';
import { ApiError } from './types';

type Translator = ReturnType<typeof useI18n>['t'];

/**
 * F65 — a user-facing message for anything a security-key ceremony can throw:
 * an API error, or the browser's own WebAuthn error. The browser reports the
 * cancel button and a timeout the same way (`NotAllowedError`) on purpose, so the
 * message covers both.
 */
export function translateSecurityKeyError(err: unknown, t: Translator): string {
  if (err instanceof ApiError || !(err instanceof Error)) return translateApiError(err, t);
  switch (err.name) {
    case 'NotAllowedError':
    case 'AbortError':
      return t('admin:securityKeys.errors.cancelled');
    case 'InvalidStateError':
      return t('admin:securityKeys.errors.alreadyAdded');
    case 'SecurityError':
      return t('admin:securityKeys.errors.wrongAddress');
    case 'TypeError':
      return translateApiError(err, t); // a failed fetch, not the key
    default:
      return t('admin:securityKeys.errors.failed');
  }
}
